const getPartnerTokens = (state) => state.partner.tokens;
const getPartnerIsLoading = (state) => state.partner.isLoading;
const getPartnerErrors = (state) => state.partner.errors;
const getDriversList = (state) => state.partner.driversList;
const getDocumentPhotos = (state) => state.partner.documentPhotos;
const getDriverInfo = (state) => state.partner.driverInfo;

export { getPartnerTokens, getPartnerIsLoading, getPartnerErrors, getDriversList, getDocumentPhotos, getDriverInfo };
